function limitarBullets(swiper, maxBullets = 5) {
  if (!swiper.pagination || !swiper.pagination.bullets) return;

  const bullets = Array.from(swiper.pagination.bullets);
  const total = bullets.length;

  if (total === 0) return;

  // se tiver loop usa realIndex, senão activeIndex
  const activeIndex = swiper.params.loop ? swiper.realIndex : swiper.activeIndex;

  // calcula a janela tentando deixar a ativa no meio
  let start = activeIndex - Math.floor(maxBullets / 2);
  let end = start + maxBullets - 1;

  if (start < 0) {
    start = 0;
    end = Math.min(total - 1, start + maxBullets - 1);
  }

  if (end >= total) {
    end = total - 1;
    start = Math.max(0, end - maxBullets + 1);
  }

  bullets.forEach((bullet, index) => {
    if (index >= start && index <= end) {
      // visíveis
      bullet.style.display = 'inline-block';
      bullet.style.opacity = '1';
      bullet.style.borderRadius = '999px';
      bullet.style.transition = 'all 0.2s ease';

      // tamanhos diferentes
      if (index === activeIndex) {
        // ativa: maior (pílula)
        bullet.style.width = '24px';
        bullet.style.height = '8px';
      } else if (index === activeIndex - 1 || index === activeIndex + 1) {
        // vizinhas: um pouco menores
        bullet.style.width = '12px';
        bullet.style.height = '8px';
      } else {
        // demais visíveis: menores
        bullet.style.width = '8px';
        bullet.style.height = '8px';
      }
    } else {
      // escondidas
      bullet.style.display = 'none';
      bullet.style.opacity = '0';
    }
  });
}

function initSwiper(container) {
  // Se o container não for especificado, usa o documento inteiro.
  const scope = container || document;

  // Encontra todos os carrosséis dentro do escopo que ainda não foram inicializados.
  const swiperElements = scope.querySelectorAll('.swiper-container-to-init:not(.swiper-initialized)');

  if (swiperElements.length === 0) return;

  swiperElements.forEach(element => {
    if (typeof Swiper === 'undefined') {
      console.error('A biblioteca Swiper.js não foi encontrada.');
      return;
    }

    let userOptions = {};
    const optionsAttribute = element.dataset.swiperOptions;
    if (optionsAttribute) {
      try {
        userOptions = JSON.parse(optionsAttribute);
      } catch (e) {
        console.error('Erro ao ler as opções JSON do Swiper:', e, element);
      }
    }

    let finalOptions = { ...userOptions };

    const paginationEl = element.querySelector('.swiper-pagination');
    if (paginationEl && userOptions.pagination !== false) {
      finalOptions.pagination = {
        el: paginationEl,
        clickable: true,
        ...userOptions.pagination
      };
    }

    const nextEl = element.querySelector('.swiper-button-next');
    const prevEl = element.querySelector('.swiper-button-prev');
    if (nextEl && prevEl && userOptions.navigation !== false) {
      finalOptions.navigation = {
        nextEl: nextEl,
        prevEl: prevEl,
        ...userOptions.navigation
      };
    }

    // Lógica para a barra de rolagem
    const scrollbarEl = element.querySelector('.swiper-scrollbar');
    if (scrollbarEl && userOptions.scrollbar !== false) {
      finalOptions.scrollbar = {
        el: scrollbarEl,
        draggable: true,
        // ADIÇÃO: Impede que a barra "pule" para a posição do clique.
        // Apenas o arraste direto no "handle" funcionará.
        dragOnly: true, 
        ...userOptions.scrollbar
      };
    }

    const swiperInstance = new Swiper(element, finalOptions);

    // Limita as bolinhas da paginação a 5 e ajusta tamanhos
    limitarBullets(swiperInstance, 5);

    swiperInstance.on('slideChange', () => {
      limitarBullets(swiperInstance, 5);
    });

    // Adiciona uma classe para marcar como inicializado e evitar reinicialização.
    element.classList.add('swiper-initialized');
  });
}

// Event listeners que rodam apenas uma vez.
document.addEventListener('DOMContentLoaded', () => initSwiper());

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    // Inicializa o Swiper apenas na nova seção que foi carregada.
    initSwiper(event.target);
  });
}
